import { ElAffix } from '@hd-front-end/components/affix'
import { ElAlert } from '@hd-front-end/components/alert'
import { ElAutocomplete } from '@hd-front-end/components/autocomplete'
import { ElAvatar } from '@hd-front-end/components/avatar'
import { ElBacktop } from '@hd-front-end/components/backtop'
import { ElBadge } from '@hd-front-end/components/badge'
import {
  ElBreadcrumb,
  ElBreadcrumbItem,
} from '@hd-front-end/components/breadcrumb'
import { ElButton, ElButtonGroup } from '@hd-front-end/components/button'
import { ElCalendar } from '@hd-front-end/components/calendar'
import { ElCard } from '@hd-front-end/components/card'
import { ElCarousel, ElCarouselItem } from '@hd-front-end/components/carousel'
import { ElCascader } from '@hd-front-end/components/cascader'
import { ElCascaderPanel } from '@hd-front-end/components/cascader-panel'
import { ElCheckTag } from '@hd-front-end/components/check-tag'
import {
  ElCheckbox,
  ElCheckboxButton,
  ElCheckboxGroup,
} from '@hd-front-end/components/checkbox'
import { ElCol } from '@hd-front-end/components/col'
import { ElCollapse, ElCollapseItem } from '@hd-front-end/components/collapse'
import { ElCollapseTransition } from '@hd-front-end/components/collapse-transition'
import { ElColorPickerPanel } from '@hd-front-end/components/color-picker-panel'
import { ElColorPicker } from '@hd-front-end/components/color-picker'
import { ElConfigProvider } from '@hd-front-end/components/config-provider'
import {
  ElAside,
  ElContainer,
  ElFooter,
  ElHeader,
  ElMain,
} from '@hd-front-end/components/container'
import { ElDatePicker } from '@hd-front-end/components/date-picker'
import { ElDatePickerPanel } from '@hd-front-end/components/date-picker-panel'
import {
  ElDescriptions,
  ElDescriptionsItem,
} from '@hd-front-end/components/descriptions'
import { ElDialog } from '@hd-front-end/components/dialog'
import { ElDivider } from '@hd-front-end/components/divider'
import { ElDrawer } from '@hd-front-end/components/drawer'
import {
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
} from '@hd-front-end/components/dropdown'
import { ElEmpty } from '@hd-front-end/components/empty'
import { ElForm, ElFormItem } from '@hd-front-end/components/form'
import { ElIcon } from '@hd-front-end/components/icon'
import { ElImage } from '@hd-front-end/components/image'
import { ElImageViewer } from '@hd-front-end/components/image-viewer'
import { ElInput } from '@hd-front-end/components/input'
import { ElInputNumber } from '@hd-front-end/components/input-number'
import { ElInputTag } from '@hd-front-end/components/input-tag'
import { ElLink } from '@hd-front-end/components/link'
import {
  ElMenu,
  ElMenuItem,
  ElMenuItemGroup,
  ElSubMenu,
} from '@hd-front-end/components/menu'
import { ElPageHeader } from '@hd-front-end/components/page-header'
import { ElPagination } from '@hd-front-end/components/pagination'
import { ElPopconfirm } from '@hd-front-end/components/popconfirm'
import { ElPopover } from '@hd-front-end/components/popover'
import { ElPopper } from '@hd-front-end/components/popper'
import { ElProgress } from '@hd-front-end/components/progress'
import {
  ElRadio,
  ElRadioButton,
  ElRadioGroup,
} from '@hd-front-end/components/radio'
import { ElRate } from '@hd-front-end/components/rate'
import { ElResult } from '@hd-front-end/components/result'
import { ElRow } from '@hd-front-end/components/row'
import { ElScrollbar } from '@hd-front-end/components/scrollbar'
import {
  ElOption,
  ElOptionGroup,
  ElSelect,
} from '@hd-front-end/components/select'
import { ElSelectV2 } from '@hd-front-end/components/select-v2'
import { ElSkeleton, ElSkeletonItem } from '@hd-front-end/components/skeleton'
import { ElSlider } from '@hd-front-end/components/slider'
import { ElSpace } from '@hd-front-end/components/space'
import { ElStatistic } from '@hd-front-end/components/statistic'
import { ElCountdown } from '@hd-front-end/components/countdown'
import { ElStep, ElSteps } from '@hd-front-end/components/steps'
import { ElSwitch } from '@hd-front-end/components/switch'
import { ElTable, ElTableColumn } from '@hd-front-end/components/table'
import { ElAutoResizer, ElTableV2 } from '@hd-front-end/components/table-v2'
import { ElTabPane, ElTabs } from '@hd-front-end/components/tabs'
import { ElTag } from '@hd-front-end/components/tag'
import { ElText } from '@hd-front-end/components/text'
import { ElTimePicker } from '@hd-front-end/components/time-picker'
import { ElTimeSelect } from '@hd-front-end/components/time-select'
import { ElTimeline, ElTimelineItem } from '@hd-front-end/components/timeline'
import { ElTooltip } from '@hd-front-end/components/tooltip'
import { ElTransfer } from '@hd-front-end/components/transfer'
import { ElTree } from '@hd-front-end/components/tree'
import { ElTreeSelect } from '@hd-front-end/components/tree-select'
import { ElTreeV2 } from '@hd-front-end/components/tree-v2'
import { ElUpload } from '@hd-front-end/components/upload'
import { ElWatermark } from '@hd-front-end/components/watermark'
import { ElTour, ElTourStep } from '@hd-front-end/components/tour'
import { ElAnchor, ElAnchorLink } from '@hd-front-end/components/anchor'
import { ElSegmented } from '@hd-front-end/components/segmented'
import { ElMention } from '@hd-front-end/components/mention'
import { ElSplitter, ElSplitterPanel } from '@hd-front-end/components/splitter'

import type { Plugin } from 'vue'

export default [
  ElAffix,
  ElAlert,
  ElAutocomplete,
  ElAutoResizer,
  ElAvatar,
  ElBacktop,
  ElBadge,
  ElBreadcrumb,
  ElBreadcrumbItem,
  ElButton,
  ElButtonGroup,
  ElCalendar,
  ElCard,
  ElCarousel,
  ElCarouselItem,
  ElCascader,
  ElCascaderPanel,
  ElCheckTag,
  ElCheckbox,
  ElCheckboxButton,
  ElCheckboxGroup,
  ElCol,
  ElCollapse,
  ElCollapseItem,
  ElCollapseTransition,
  ElColorPickerPanel,
  ElColorPicker,
  ElConfigProvider,
  ElContainer,
  ElAside,
  ElFooter,
  ElHeader,
  ElMain,
  ElDatePicker,
  ElDatePickerPanel,
  ElDescriptions,
  ElDescriptionsItem,
  ElDialog,
  ElDivider,
  ElDrawer,
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElEmpty,
  ElForm,
  ElFormItem,
  ElIcon,
  ElImage,
  ElImageViewer,
  ElInput,
  ElInputNumber,
  ElInputTag,
  ElLink,
  ElMenu,
  ElMenuItem,
  ElMenuItemGroup,
  ElSubMenu,
  ElPageHeader,
  ElPagination,
  ElPopconfirm,
  ElPopover,
  ElPopper,
  ElProgress,
  ElRadio,
  ElRadioButton,
  ElRadioGroup,
  ElRate,
  ElResult,
  ElRow,
  ElScrollbar,
  ElSelect,
  ElOption,
  ElOptionGroup,
  ElSelectV2,
  ElSkeleton,
  ElSkeletonItem,
  ElSlider,
  ElSpace,
  ElStatistic,
  ElCountdown,
  ElSteps,
  ElStep,
  ElSwitch,
  ElTable,
  ElTableColumn,
  ElTableV2,
  ElTabs,
  ElTabPane,
  ElTag,
  ElText,
  ElTimePicker,
  ElTimeSelect,
  ElTimeline,
  ElTimelineItem,
  ElTooltip,
  ElTransfer,
  ElTree,
  ElTreeSelect,
  ElTreeV2,
  ElUpload,
  ElWatermark,
  ElTour,
  ElTourStep,
  ElAnchor,
  ElAnchorLink,
  ElSegmented,
  ElMention,
  ElSplitter,
  ElSplitterPanel,
] as Plugin[]
